import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "booking-view departures"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "center-wrapper" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "space-wrapper" }
const _hoisted_6 = {
  key: 1,
  class: "error-message",
  role: "alert"
}
const _hoisted_7 = {
  href: "/",
  class: "btn-primary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FlightFilter = _resolveComponent("FlightFilter")!
  const _component_FlightSorting = _resolveComponent("FlightSorting")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_EasyDrop = _resolveComponent("EasyDrop")!
  const _component_FlightList = _resolveComponent("FlightList")!
  const _component_DotSpinner = _resolveComponent("DotSpinner")!

  return (_ctx.flightRecommendations)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("header", null, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.pageTexts['hotelPageFlightStepHeadline']), 1),
            _createElementVNode("div", null, [
              (_ctx.flightRecommendations.searchFilter)
                ? (_openBlock(), _createBlock(_component_FlightFilter, {
                    key: 0,
                    filters: _ctx.flightRecommendations.searchFilter,
                    localeStrings: _ctx.localeStrings,
                    onUpdateFilteredFlights: _ctx.updateFilteredFlights,
                    pageTexts: _ctx.pageTexts
                  }, null, 8, ["filters", "localeStrings", "onUpdateFilteredFlights", "pageTexts"]))
                : _createCommentVNode("", true),
              (_ctx.flightRecommendations.sorting.items)
                ? (_openBlock(), _createBlock(_component_FlightSorting, {
                    key: 1,
                    sortItems: _ctx.flightRecommendations.sorting.items,
                    onUpdateFilteredFlights: _ctx.updateFilteredFlights,
                    pageTexts: _ctx.pageTexts
                  }, null, 8, ["sortItems", "onUpdateFilteredFlights", "pageTexts"]))
                : _createCommentVNode("", true),
              _createVNode(_component_router_link, {
                class: "back-btn",
                title: _ctx.pageTexts['hotelPageNavigationButtonPrevious'],
                to: { name: 'pension', query: _ctx.query }
              }, null, 8, ["title", "to"]),
              (_ctx.pageTexts['hotelPageFlightStepInfoPopup'])
                ? (_openBlock(), _createBlock(_component_EasyDrop, {
                    key: 2,
                    dropdownType: 'tooltip',
                    position: 'right'
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "rte",
                        innerHTML: _ctx.pageTexts['hotelPageFlightStepInfoPopup']
                      }, null, 8, _hoisted_2)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("strong", null, _toDisplayString(_ctx.flightRecommendations.paging.totalResults) + " " + _toDisplayString(_ctx.pageTexts['hotelPageFlightStepHeadlineFlightCount']), 1)
          ]),
          (!_ctx.hasErrorResponse)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("fieldset", null, [
                  _createVNode(_component_FlightList, {
                    flightRecommendations: _ctx.flightRecommendations,
                    selectedFlight: _ctx.selectedFlight,
                    pageTexts: _ctx.pageTexts,
                    localeStrings: _ctx.localeStrings,
                    onUpdateFilteredFlights: _ctx.updateFilteredFlights
                  }, null, 8, ["flightRecommendations", "selectedFlight", "pageTexts", "localeStrings", "onUpdateFilteredFlights"])
                ]),
                _createElementVNode("div", _hoisted_3, [
                  (
            _ctx.flightRecommendations.paging?.pageNumber <
            _ctx.flightRecommendations.paging?.numberOfPages || _ctx.flightRecommendations.paging?.pageNumber === 1 && _ctx.flightRecommendations.paging?.totalResults > 2
          )
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn-secondary",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addPage && _ctx.addPage(...args)))
                      }, [
                        (_ctx.isPageLoading)
                          ? (_openBlock(), _createBlock(_component_DotSpinner, { key: 0 }))
                          : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.pageTexts['hotelPageFlightStepLabelButtonShowMoreFlights']), 1))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  (_ctx.bookingOverview.transfers.length)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        class: "btn-primary",
                        to: { name: 'transfer', query: _ctx.query }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPageNavigationButtonNext']), 1)
                        ]),
                        _: 1
                      }, 8, ["to"]))
                    : (_openBlock(), _createBlock(_component_router_link, {
                        key: 1,
                        class: "btn-primary",
                        to: { name: 'personal-data', query: _ctx.query }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPageNavigationButtonNext']), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])),
                  _createVNode(_component_router_link, {
                    class: "prev",
                    to: { name: 'pension', query: _ctx.query }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.pageTexts['hotelPageNavigationButtonPrevious']), 1)
                    ]),
                    _: 1
                  }, 8, ["to"])
                ])
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.pageTexts['hotelPageGeneralErrorHeadline']), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.errorResponseMessage), 1),
                _createElementVNode("a", _hoisted_7, _toDisplayString(_ctx.pageTexts['hotelListPageSearchFilterButtonBackTitle']), 1)
              ]))
        ])
      ]))
    : _createCommentVNode("", true)
}